"use strict";
/* 
var bis = require("./bis");
 */
let baseMethods = require("./base").methods;
let handlePostCartAdd = baseMethods.handlePostCartAdd;
let miniCartReportingUrl = baseMethods.miniCartReportingUrl;
let attributeSelect = baseMethods.attributeSelect;

module.exports = {
    handleAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            if (response.isSetItem) {
                if (response.product.orderable === false) {
                    $("button.add-to-cart", response.$productContainer).attr("disabled", true);
                    return;
                }

                if (response.product.isCTADisabled) {
                    $("button.add-to-cart", response.$productContainer).attr("disabled", true);
                    return;
                }

                // update local add to cart (for sets)
                var buttonState = (!response.product.readyToOrder || !response.product.available);
                $("button.add-to-cart", response.$productContainer).attr("disabled", buttonState);
            }
        });

        $(document).on("click", ".set-item.product-tile button.add-to-cart", function () {
            var addToCartUrl;
            var pid;
            var quantity = 1;
            var $this = $(this);
            var $productContainer = $this.closest(".set-item");

            $("body").trigger("product:beforeAddToCart", this);

            pid = $productContainer.data("pid");
            addToCartUrl = $productContainer.find(".add-to-cart-url").val();
            quantity = $productContainer.find("select.quantity-select").val();

            var form = {
                pid: pid,
                pidsObj: [],
                childProducts: [],
                quantity: quantity
            };

            $(this).trigger("updateAddToCartFormData", form);
            $.ajax({
                url: addToCartUrl,
                method: "POST",
                data: form,
                success: function (data) {
                    handlePostCartAdd(data, $productContainer);
                    $("body").trigger("product:afterAddToCart", data);
                    $.spinner().stop();
                    miniCartReportingUrl(data.reportingURL);
                },
                error: function (e) {
                    var response = JSON.parse(e.responseText);
                    if ($(".add-to-cart-messages").length === 0) {
                        $("body").append("<div class=\"add-to-cart-messages\"></div>");
                    }
                    $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + response.errorMessage + "</div>");
                    setTimeout(function () {
                        $(".add-to-basket-alert").remove();
                    }, 3000);
                    $.spinner().stop();
                }
            });
        });
    },
    handleAvailability: function () {
        $("body").on("setItem:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            $("button.add-to-cart", response.$productContainer).empty()
                .html(!response.product.available ? response.resources.outOfStock : (response.product.readyToOrder ? (response.product.isPlayTest ? response.resources.playTest : response.resources.addtocartText) : response.resources.info_selectforstock));

            if (response.$productContainer.closest(".stand-alone-item").length > -1) {
                if ($(".global-availability").length) {
                    var allAvailable = $(".product-availability").toArray()
                        .every(function (item) { return $(item).data("available"); });

                    var allReady = $(".product-availability").toArray()
                        .every(function (item) { return $(item).data("ready-to-order"); });

                    $(".global-availability")
                        .data("ready-to-order", allReady)
                        .data("available", allAvailable);

                    $(".global-availability .availability-msg").empty()
                        .html(allReady ? response.message : response.resources.info_selectforstock);
                }
            }
        });
    },
    preselectVariation: function () {
        let $setItemTiles = $(".set-item.product-tile");

        if ($setItemTiles.length === 0) {
            return;
        }

        let setItemTilesArray = $setItemTiles.toArray();

        for (let i = 0; i < setItemTilesArray.length; i++) {
            let $productTile = $(setItemTilesArray[i]);
            let $colorAttr = $productTile.find(".color-attribute").eq(0);

            if ($colorAttr.length === 0) {
                continue;
            }

            $colorAttr.attr("selected", "selected").addClass("selected");
            attributeSelect($colorAttr.data("url"), $productTile);
        }
    }
};
